import { isHomecenterOrderRole } from '../constants/roleIds'

export const CREAR_ENVIO_STORES_DEFAULT =
  'Bigcenter,Distrito Cafetero,Artiq,Garantias,Baristico'

export const CREAR_ENVIO_HOMECENTER_STORE = 'Homecenter'

export function getCrearEnvioStores(roleId: number | undefined | null): string {
  if (isHomecenterOrderRole(roleId)) {
    return CREAR_ENVIO_HOMECENTER_STORE
  }
  return CREAR_ENVIO_STORES_DEFAULT
}
